interface Config {
    backendUrl: string;
    wsBackendUrl: string;
    msalClientID: string;
    msalBackendScope: string;
}

export const config: Config = {
    backendUrl: import.meta.env.VITE_BACKEND_URL as string + '/sgapi',
    wsBackendUrl: import.meta.env.VITE_BACKEND_WS_URL as string,
    msalClientID: import.meta.env.VITE_MSAL_CLIENT_ID as string,
    msalBackendScope: import.meta.env.VITE_MSAL_BACKEND_SCOPE as string
};
